import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScoringComponent } from './scoring.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectAcademicYearOnlyModule } from 'src/shared/modules/select-academic-year-only/select-academic-year-only.module';
import { SelectSchoolProgramModule } from 'src/shared/modules/select-school-program/select-school-program.module';
import { SelectSchoolActivityModule } from 'src/shared/modules/select-school-activity/select-school-activity.module';
import { SelectSchoolLevelRelationV2Module } from 'src/shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module';
import { SelectSchoolProgramCategoryModule } from 'src/shared/modules/select-school-program-category/select-school-program-category.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { PipeModule } from 'src/shared/pipes/pipe.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FeatherModule } from "angular-feather";
import { RevoGrid } from '@revolist/angular-datagrid';
import { StatusLoadingModule } from 'src/shared/modules/status-loading/status-loading.module';

@NgModule({
  declarations: [ScoringComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SelectAcademicYearOnlyModule,
    SelectSchoolProgramModule,
    SelectSchoolProgramCategoryModule,
    SelectSchoolActivityModule,
    SelectSchoolLevelRelationV2Module,
    MatTableModule,
    MatSortModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatOptionModule,
    NgxDropzoneModule,
    PipeModule,
    FeatherModule,
    RevoGrid,
    StatusLoadingModule
],
  exports: [ScoringComponent]
})
export class ScoringModule { }
